import configuration from "../configuration/keys";
import {
  E_ADMIN_ROLE,
  TAdmin,
  TAdminRole,
  TAdminVersionStates,
  TCorePage
} from "../Types";
import { TKhattabatOneOTwoMessageMetadata } from "../types/khattabat-one-o-two-message.type";

export const ADMIN_VERSION_DEFAULT_STATES: TAdminVersionStates = {
  isActive: true,
  isUnderMaintenance: false,
  latestAdminVersion: configuration.version
};

export const MONITORED_KHATTABAT_PAGES: TCorePage[] = [
  "KHATTABAT_MATCHING_RESULTS",
  "KHATTABAT_M",
  "KHATTABAT_F"
];

// Refresh interval for Khattabat pages: 60000 ms (60 seconds)
export const KHATTABAT_PAGES_REFRESH_INTERVAL = 60000;

export const SESSION_HOURS_TIME_LIMIT = 8;
export const ONE_DAY_TOTAL_HOURS = 24;

export const MAX_KHATTABA_ASSIGNEES = 100;

export const MIN_KHATTABA_ASSIGNEES = 1;

export const KHATTABAT_ONE_O_TWO_MIN_QUALITY_MESSAGES = 50;

export const KHATTABAT_ONE_O_TWO_DEFAULT_MESSAGE_METADATA: TKhattabatOneOTwoMessageMetadata =
  {
    reactionId: 0,
    reactions: [],
    reactionHistory: [],
    isHidden: 0,
    hiddenActions: [],
    hideHistory: []
  };

export const KHATTABAT_REACTIVATION_DELAY_DAYS = 30;

export const ONE_MONTH_RANGE = 32;

export const DEFAULT_KHATTABAT_AI_FLTER_STATUS_VALUE = {
  label: "All",
  value: "all"
};

export const DEFAULT_KHATTABAT_USER_LOGOUT: TAdmin = {
  id: -1,
  username: "",
  fullName: "",
  role: "",
  lastLogin: "",
  needResetPassword: false
};

export const KHATTABA_POSSIBLE_ROLES: TAdminRole[] = [
  E_ADMIN_ROLE.KHATTABA_ADMIN,
  E_ADMIN_ROLE.KHATTABA_ADMIN_AI,
  E_ADMIN_ROLE.KHATTABA_ADMIN_TESTER
];
